import { Opacity } from "@mui/icons-material";
import { Theme } from "@mui/material";
import { fontWeight } from "@mui/system";

const useStyles = (theme: Theme) => {
  return {
    stack: {
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
      borderRadius: "12px",
      background: theme.palette.background.paper,
    },

    stackText: {
      display: "flex",
      alignItems: "start",
      justifyContent: "start",
      overflow: "hidden",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      padding: 0.5,
    },

    image: {
      opacity: "50%",
      maxWidth: "45%",
      maxHeight: "45%",
    },

    label: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "100%",
      fontSize: "1.2rem",
      fontWeight: "500",
      color: theme.palette.text.disabled,
    },
  };
};

export default useStyles;
